import classNames from "classnames";

import { StorePickerConfig } from "@/components/Store/StorePicker/types/storePickerConfig.type";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { StoreStatus } from "@/components/Store/StoreSearch/components/list/storeCard/storeStatus/storeStatus.component";
import { TStoreStatus } from "@/components/Store/utils/storeInfo";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { StoreProductAvailabilityComponent } from "./components/storeProductAvailability/storeProductAvailability.component";

import "./storeCard.scss";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { Button } from "@omni/ui/components/Button/button.component";

type StoreCardComponentProps = {
    storeName: string;
    isDisabled: boolean;
    isSelected: boolean;
    handleOnStoreClick: () => void;
    handleSubmit: () => void;
    storeStatus: TStoreStatus;
    statusText: string;
    address: string;
    productAvailability?: CloudProductAvailability | null;
    config: StorePickerConfig;
};

const StoreCardComponent = ({
    storeName,
    isDisabled,
    isSelected,
    handleOnStoreClick,
    handleSubmit,
    storeStatus,
    statusText,
    address,
    productAvailability,
    config
}: StoreCardComponentProps) => {
    const { t } = useGranite();

    return (
        <li
            className={classNames(
                "store-picker-card",
                isSelected && !isDisabled && "store-picker-card--selected",
                isDisabled && "store-picker-card--disabled"
            )}
            onClick={handleOnStoreClick}
        >
            <p className={"store-picker-card__title"}>{storeName}</p>
            <div className="d-flex flex-row justify-content-between flex-wrap">
                <div className="d-flex flex-column mr-3">
                    <StoreStatus
                        isOpen={storeStatus.isOpen}
                        openClosesAt={storeStatus.text2}
                        statusText={statusText}
                    />
                    <p className={"m-0"}>
                        <i className={"mr-2 las la-map-marker"}></i>
                        {address}
                    </p>
                    {productAvailability && (
                        <StoreProductAvailabilityComponent
                            productAvailability={productAvailability}
                        />
                    )}
                </div>

                {(config.type === StorePickerType.SELECT ||
                    config.type === StorePickerType.SELECT_DRIVE_IN) && (
                    <div className="d-flex align-self-end mt-2">
                        <Button
                            test="storePicker-button-submit"
                            onClick={handleSubmit}
                            disabled={isDisabled}
                            type={"button"}
                            fullWidth={true}
                        >
                            <strong>
                                {config.submitButtonText ||
                                    t(
                                        "general.storepicker.button.confirmStore"
                                    )}
                            </strong>
                        </Button>
                    </div>
                )}
            </div>
        </li>
    );
};

export { StoreCardComponent };
